export default "__VITE_ASSET__Df9ubPfc__"